<div *ngIf="headerTitle$ | async as headerTitle">
  <h5
    class="color-900 font-family-heavy border-bottom mb-0 pt-3 mt-1 list-title"
    >{{ headerTitle }}</h5
  >
  <ul>
    <li
      *ngFor="let node of nodes$ | async; let i = index; trackBy: trackById"
      class="py-3 border-bottom"
    >
      <a
        class="primary-color-text-hover w-100"
        [routerLink]="node.slug_uri"
        data-test="node-list-widget-item-link"
        floAnalytics
        [analyticsProperties]="node.analytics"
      >
        <div class="d-flex flex-row align-items-center col-12 px-0 py-1">
          <div
            class="ps-0 pe-0 pe-sm-2 col-lg-4 col-md-2 col-sm-2 col-3 me-3 me-sm-2"
          >
            <div
              class="position-relative top right overflow-hidden rounded color-ignite bg-dark"
              style="padding-top: 75%"
            >
              <img
                [src]="node?.asset?.url | floImage: 200 | async"
                [alt]="node?.short_title"
                class="img-fluid rounded position-absolute h-100 w-100 top left bottom right"
                style="object-fit: cover"
              />
            </div>
          </div>
          <div class="col-lg-8 col-md-10 col-sm-10 col-9 px-0 align-self-start">
            <h5
              class="color-800 font-family-bold mb-0 apply-text-hover text-line-clamp-2"
              >{{ node?.short_title }}</h5
            >
            <span class="flo-footnote d-flex">{{
              node?.publish_start_date | floDateYear: node?.publish_end_date
            }}</span>
          </div>
        </div>
      </a>
    </li>
  </ul>
</div>
